import {combineReducers} from "redux";
import customerReducer from "./customer.reducer";
import reducer from "./index";
import accountReducer from "./account";
import storeReducer from "./store";
import bookingReducer from "./booking";
import appointmentReducer from "./appointment";
import globalReducer from "./global.reducer";
import {persistReducer} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import {encryptTransform} from "redux-persist-transform-encrypt";

const persistConfig = {
  key: "root",
  blacklist: [
    // "globalReducer",
    "appnDetails",
    "bookingDetails",
    "reducer",
    // "customerReducer",
  ],
  storage: storageSession,
  transforms: [
    encryptTransform({
      secretKey: process.env.REDUX_PERSIST_SECRET_KEY,
      onError: function () {},
    }),
  ],
};

const allReducers = combineReducers({
  customerReducer,
  reducer,
  account: accountReducer,
  store: storeReducer,
  bookingDetails: bookingReducer,
  appnDetails: appointmentReducer,
  globalReducer,
});

export const persistAllReducer = persistReducer(persistConfig, allReducers);
